// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_RunNowInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_RunNowInput — body for POST /scheduled-jobs/run-now.
 *
 * Executes the job's job_type executor immediately, ignoring both `enabled`
 * and `next_run_at` — the S10 sweep-transition PASSO 2 "prova no ambiente
 * real" action (a job seeded with enabled=0 must still be runnable once,
 * on demand, before the flip). Goes through the SAME lease / overlap /
 * attempts / dead-letter machinery as a real tick (see
 * Scheduled_jobs::runJobNow() in the controller) — a manual run is not a
 * separate, looser code path.
 */
import { registerContract } from './validate'

export interface ScheduledJobs_RunNowInput {
id: number
}

registerContract('ScheduledJobs_RunNowInput', {
  id: { type: 'number',  required: true },
})
